

import RefreshNotifications from './RefreshNotifications';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Spinner, Button, Badge, Table, Container, Row, Col, Modal, Form } from 'react-bootstrap';
import validator from 'validator';
import ShowDaneStatus from './ShowDaneStatus';
import ShowDaneWeekendDay from './ShowDaneWeekendDay';
import { useContext } from 'react';

import { AppContext } from './context/AppContext';
import { jwtDecode } from "jwt-decode";
import { Link } from 'react-router-dom';
import ShowDaneStatusPublicView from './ShowDaneStatusPublicView';

const PublicDaneDatesLisingView = ({tenantId, tenantName,tenantAddress}) => {

  const { setToken, token, setUser, currentUser, setLoadingApp } = useContext(AppContext);

  const[data, setdata] = useState(null); 
  const[error, setError] = useState(null); 
  
  const dataFetchedRef = useRef(false);

  const[currentMonth, setcurrentMonth] = useState(null); 

  const [monthno, setmonthno] = useState(0);

  const[refresh, setRefresh] = useState(false); 
  const [inProgress, setInProgress] = useState(false);
  const [nextprogress, setnextprogress] = useState(false);
  const [prevprogress, setprevprogress] = useState(false);
  

  useEffect(()=>{

        let baseURL = process.env.REACT_APP_API_BASE_URL + 'DaneDates/getpuplicdata/' + tenantId + '/'+ monthno;
      
          let headers = {
            'Content-Type': 'application/json',  
            //'Authorization': 'Bearer '+ token ,    
          };
         

        //console.log(baseURL)

        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

        axios.get(baseURL,{headers})        
          .then((Response)=>{
              setdata(Response.data);

              let currData = Response.data
              let sdate = currData[0].date;             
              setcurrentMonth(retrunMonthName(sdate));  

          }).catch(error => {
              //setError(error);     
              //console.log({error})
              //console.log(error.message)
              //alert(error.message)
                setError(error);  
              

          });

          setnextprogress(false); 
          setprevprogress(false)

    },[refresh])
  
    const prevClick = () => { 
      setprevprogress(true);
      setmonthno(pre=>(pre-1));
      dataFetchedRef.current = false; 
      setRefresh(!refresh);   
    }
    
    const nextClick = () => { 
      setnextprogress(true);
      setmonthno(pre=>(pre + 1 ));
      dataFetchedRef.current = false; 
      setRefresh(!refresh);   
    }
    
    const setCurrMonth = () =>{
      setmonthno(0);
      dataFetchedRef.current = false; 
      setRefresh(!refresh);  
    }    

function retrunMonthName(sdate){

    const monthNames = ["January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                        ];
    const d = new Date(sdate);
    return monthNames[d.getMonth()] + ' ' + d.getFullYear();
}


    if (error) 
    { 
        return "Error:" + error.message;
    }

    if(!data) return (
        <Spinner animation="border" variant="primary" />
        );

//console.log(currentUser);

  return (
    <>
  

<Container fluid="md" style={{marginTop:'5px'}}>
      <Row>
        <Col className='col-2'> 
           <img src="/mahamevnawalogo.png" alt="mahamevnawa London" height={"65px"} style={{marginBottom:"3px"}} />        
        </Col>
        <Col className='col-10'>
          <span> <b>නමෝ බුද්ධාය</b> - <b>{tenantName}</b> අසපුව - <b>දානය</b></span>
           <h2>        
          <Button size='sm' style={{color:'black',fontSize:"12px" }} variant="outline-warning" disabled={monthno===0} onClick={prevClick} > &lt; Prev Month </Button>&nbsp;
          {monthno > 1 && <><Button variant="secondary" size='sm' onClick={setCurrMonth}>This Month</Button>&nbsp;</>} 
          <Badge style={{backgroundColor:'orange', color:'black', fontSize:"18px" }} bg="xsecondary">         
            {currentMonth}        
          </Badge>&nbsp;        
          <Button size='sm' style={{color:'black',fontSize:"12px" }} variant="outline-warning" disabled={(currentUser.accesstype !== "admin" && monthno > 1) || nextprogress  } onClick={nextClick} >
            {nextprogress && <><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></>}
            {!nextprogress && <>Next Month&gt; </>}
          </Button> &nbsp;&nbsp;          
          </h2>         
                 
       </Col>
       </Row>
        
      <Row>
        <Col>         
          <Table bordered hover responsive="sm" size='sm' variant="light">
            <thead>
              <tr key="header00">
                <th key="header0" style={{backgroundColor:'orange', fontSize:"12px", fontWeight:"bold"}}>දිනය</th>
                <th key="header1" style={{backgroundColor:'orange',fontSize:"12px"}}>දවස</th>
                <th key="header2" style={{backgroundColor:'orange'}}></th>
                <th key="header3" style={{backgroundColor:'orange', fontSize:"12px", fontWeight:"bold"}}>උදෑසන දනය</th>
                <th key="header4" style={{backgroundColor:'orange', fontSize:"12px", fontWeight:"bold"}}>දහවල්  දනය</th>
                {currentUser.accesstype === "admin" && <th key="header5" style={{backgroundColor:'orange'}}></th>}
              </tr>
            </thead>
            <tbody>

              {data && data.map((item)=>{   


                  let bgColour = ""
                  if(item.datetype === "weekend" && item.day==="Saturday") bgColour = "#fff3cc";
                  if(item.datetype === "weekend" && item.day==="Sunday") bgColour = "#fff3cc";
                  if(item.badgeText !== "") bgColour = "Gold";

              
                  return(
                      <>              
                      <tr key={item.date} style={{fontSize:"15px"}} >
                        <td valign='middle' style={{backgroundColor:bgColour}} width={"10%"} ><strong>{item.date}</strong>
                        </td>
                        <td valign='middle' width={"6%"} style={{backgroundColor:bgColour,textAlign:"left",fontSize:"15px"}}>
                        <ShowDaneWeekendDay sdaytype={item.datetype} sday={item.day} /> 
                        </td>
                        <td width={"16%"} style={{backgroundColor:bgColour, textAlign:"left", padding:"1px"}}>            
                        {item.badgeText !== "" && <span> <Badge bg="warning" style={{color:"black", fontSize:"15px"}}>{item.badgeText}</Badge></span>}                        
                        {item.notificationText !== "" && <span style={{color:"black", fontSize:"15px"}}>&nbsp;{item.notificationText}</span>}
                        </td>
                        

                        <td valign='middle' style={{backgroundColor:bgColour}} width={"6%"} >
                            <Container fluid>
                            <Row>
                                <Col><ShowDaneStatusPublicView dataItemstatus={String(item.heelDaneTaken)} itemObj={item} DaneTime = "heel"/></Col>                            
                            </Row>                   
                            </Container>            
                        </td>
                        
                        <td valign='middle' style={{backgroundColor:bgColour}} width={"6%"} >                
                            <Container fluid>
                                <Row>
                                <Col><ShowDaneStatusPublicView dataItemstatus={String(item.dahawalDaneTaken)} itemObj={item} DaneTime = "dahawal" /></Col>
                            </Row>                   
                            </Container>                 
                        </td>
                                                
                      </tr>                
                </>                
                )         
              })}
              
            </tbody>
        </Table>
      </Col>
      </Row>
      <Row>
       <Col>    
       {/* <h3>{refreshSignalR}</h3> */}
        <h2>
        <Button size='sm' style={{color:'black',fontSize:"12px" }} variant="outline-warning" disabled={monthno===0} onClick={prevClick} > &lt; Prev Month </Button>&nbsp;
        {monthno > 1 && <><Button variant="secondary" size='sm' onClick={setCurrMonth}>This Month</Button>&nbsp;</>} 
        <Badge style={{backgroundColor:'orange', color:'black', fontSize:"18px" }} bg="xsecondary">         
          {currentMonth}        
        </Badge>&nbsp;        
        <Button size='sm' style={{color:'black',fontSize:"12px" }} variant="outline-warning" disabled={currentUser.accesstype !== "admin" && monthno > 1 } onClick={nextClick} >Next Month&gt; </Button> &nbsp;&nbsp;
        </h2>    
        
        </Col>
      </Row>  

      <Row>
        <Col>       
       <hr></hr>       
       <h6><b>{tenantName} අසපුව</b> {tenantAddress}  </h6>
       <hr></hr>
        </Col>
      </Row>  
     
    </Container>


    </>

  )
}

export default PublicDaneDatesLisingView